import { useMemo } from "react";

import type * as Type from "../type";

type Props = {
	serverData: Type.ServerData.ReservationListByCInDateServerData | undefined;
};
type Result = {
	queryData: Type.QueryData.ReservationListQueryData | undefined;
};

export const useReservationListByCInDateQueryData = ({ serverData }: Props) => {
	return useMemo(
		(): Result => ({
			queryData: serverData
				? {
						hotelName: serverData.reservationListByCInDate.hotelName,
						hotelPrefecture: serverData.reservationListByCInDate.hotelPrefecture,
						reservationList: serverData.reservationListByCInDate.reservations,
					}
				: undefined,
		}),
		[serverData],
	);
};
